<template>
  <b-container>
    <b-row>
      <b-col style="max-width:45px;"><b-spinner label="Loading..."></b-spinner></b-col>
      <b-col style="padding-top:3px;">Loading...</b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: 'Spinner'
}
</script>
